import { Injectable } from '@angular/core';
import translateJson from "../../../translate.json";


@Injectable()
export class Formvalidator {

    formValidation: any;
    numberSpaceChar = new RegExp("^[A-Öa-ö0-9 -]*[A-Öa-ö0-9][A-Öa-ö0-9 -]*$");
    mailValidator = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
    private i18 = translateJson.i18;

    constructor() {
        this.setDefault();
    }

    setDefault(){
        this.formValidation = {
            compProjectError: false,
            secContractError: false,
            projectDateError: false,
            compIndustryError: false,
            noCompanySelected: false,
            recieverPersonError: false,
            suaNameError: false,
            suaSecHandlerNameError: false,
            suaSecHandlerPhoneError: false,
            suaSecHandlerMailError: false,
            suaProjectSecManagerNameError: false,
            suaProjectSecManagerPhoneError: false,
            suaProjectSecManagerMailError: false,
            orgNrOperatorError: false,
            orgNrSupervisorError: false,
            suaNameClarificationError: false
        }
    }   

    /**     
     * Validates that the operator organisation number is set
     */
     validateOrgNrOperator(orgNrOperator: string) {
        if (orgNrOperator == null || orgNrOperator.trim().length < 1) {
            this.formValidation.orgNrOperatorError = false;
        } else if (!this.validateOrgId(orgNrOperator)){
            this.formValidation.orgNrOperatorError = true;           
        } else {
            this.formValidation.orgNrOperatorError = false;
        }
        return !this.formValidation.orgNrOperatorError;
    }

     /**
     * Validates that the supervisor organisation number is set
     */
      validateOrgNrSupervisor(orgNrSupervisor: string) {
        if (orgNrSupervisor == null || orgNrSupervisor.trim().length < 1) {
            this.formValidation.orgNrSupervisorError = false;
        } else if (!this.validateOrgId(orgNrSupervisor)){
            this.formValidation.orgNrSupervisorError = true;           
        } else {
            this.formValidation.orgNrSupervisorError = false;
        }
        return !this.formValidation.orgNrSupervisorError;
    }

    /**
     * Validate organisation id
     * @param id employer name from form
     */
     validateOrgId(id) {
        if(id === null || id === "" || id === undefined) {           
            return false;
        }

        if (id.length > 11) {
            return false;
        }

        if(id.charAt(0) === '2' || id.charAt(0) === '3' || id.charAt(0) === '5' || id.charAt(0) === '6') {
            if(!(id.trim().replace(/\D/g, "").length === 10)) {                
                return false;
            }
        }

        id = id.match(/[0-9]{6}-[0-9]{4}/g);
            if(id === null){                
                return false;
            } else {
                id = id[0];
            }

            id = id
            .replace(/\D/g, "")     // strip out all but digits
            .split("")              // convert string to array
            .reverse()              // reverse order for Luhn

            // verify we got 10 digits, otherwise it is invalid
            if (id.length != 10) {               
                return false;
            }

            var sum = id
                // convert to number
                .map(function(n) {
                    return Number(n);
                })
                // perform arithmetic and return sum
                .reduce(function(previous, current, index) {
                    // multiply every other number with two
                    if (index % 2) current *= 2;
                    // if larger than 10 get sum of individual digits (also n-9)
                    if (current > 9) current -= 9;
                    // sum it up
                    return previous + current;
                });

            // sum must be divisible by 10   
            if (0 === sum % 10) {
                return true;   
            } 

        return false;
    }

    /**
     * Validate project name
     * @param input Project name    
     */
    validateProjectCompanySelected(input) {
        if(input === null || input === "") {           
            return this.formValidation.noCompanySelected = true;
        }
    }

    /**
     * Validate project name
     * @param input Project name    
     */
    validateCompProject(input) {
        if(input === null || input === "") {           
            return this.formValidation.compProjectError = true;
        } else {
            return this.formValidation.compProjectError = false;
        }
    }

    /**
     * Validate compIndustry name
     * @param input Project name    
     */
    validateCompIndustry(input) {
        if(input == null || input === "") {           
            return this.formValidation.compIndustryError = true;
        }
        else {
            return this.formValidation.compIndustryError = false;
        }
    }

    /**
     * Validate Security contract option 
     * @param input Option selected    
     */
    validateSecContractSelected(input) {
        if(input != "levelOne" && input != "levelTwo" && input != "levelThree") {            
            return this.formValidation.secContractError = true;
        } else {
            return this.formValidation.secContractError = false;
        }
    }

    /**
     * Validate Security contract option 
     * @param input Option selected    
     */
    validateSupplierType(input) {
        if(input != "headSupplier" && input != "subSupplier" && input != "customerSupplier") {          
            return this.formValidation.secContractError = true;
        } else {
            return this.formValidation.secContractError = false;
        }
    }

    /**
     * Validate project date (not null) 
     * @param input Date    
     */
    validateProjectDate(input) {
        if(isNaN(Date.parse(input))) {          
            return this.formValidation.projectDateError = true;
        } else {
            return this.formValidation.projectDateError = false;
        }
    }

    /**
    * Method used to validate a receiver person before allowing a save
    */
   validateRecieverPerson(personInput) {       
        if (personInput != null && personInput !== '' && personInput.trim().length < 2) {
            this.formValidation.recieverPersonError = true; 
        } else {
            this.formValidation.recieverPersonError = false;
        }
        return this.formValidation.recieverPersonError;
    }

    /**
     * Validate Sua name
     * @param suaName 
     * @returns 
     */
    validateSuaName(suaName: string) {
        if (suaName === null || suaName.trim().length < 1) {
            return this.formValidation.suaNameError = false;
        } else if (suaName.trim().length < 2) {
            return this.formValidation.suaNameError = true;
        }
        return this.formValidation.suaNameError = false;
    }

    /**
     * Validate sec handler name
     * @param secHandlerName 
     */
    validateSecHandlerName(secHandlerName: string) {
        if (secHandlerName === null || secHandlerName.trim().length < 1) {
            return this.formValidation.suaSecHandlerNameError = false;
        } else if (secHandlerName.trim().length < 2) {
            return this.formValidation.suaSecHandlerNameError = true;
        }
        return this.formValidation.suaSecHandlerNameError = false;
    }

    /**
     * Validate phone number
     * @param secHandlerPhone 
     * @returns 
     */
     validateSecHandlerPhone(secHandlerPhone: any) {
        secHandlerPhone = secHandlerPhone.replaceAll(" ", "")  // strip out all white spaces
        if (secHandlerPhone === null || secHandlerPhone.trim().length < 1) {
            return this.formValidation.suaSecHandlerPhoneError = false;
        } else if (secHandlerPhone != null && secHandlerPhone.trim().length < 5) {
           return this.formValidation.suaSecHandlerPhoneError = true;           
        } else {        
            if (!secHandlerPhone.match(/^[0-9-+]+$/g)) {                
                return this.formValidation.suaSecHandlerPhoneError = true;
            } else {
                return this.formValidation.suaSecHandlerPhoneError = false;                
            }
       }       
    }

    /**
     * Validate sec handler email
     * @param secHandlerMail 
     * @returns 
     */
    validateSecHandlerMail(secHandlerMail) {
        if (secHandlerMail === null || secHandlerMail.length < 1) {
            return this.formValidation.suaSecHandlerMailError = false;
        } else if (!this.isValidContactMail(secHandlerMail)) {           
            return this.formValidation.suaSecHandlerMailError = true;
        }
        return this.formValidation.suaSecHandlerMailError = false;
    }

    /**
     * Checks the validity of a contact mail and sets modalData error message appropriate to the mail error.
     * @param mail E-mail address.     
     */
     isValidContactMail(mail) {
        if (this.mailValidator.test(mail)) {
            return true;
        }        
        return false;
    }

    /**
     * Validate project manager name
     * @param projectSecManagerName 
     * @returns 
     */
    validateProjectSecManagerName(projectSecManagerName: string) {
        if (projectSecManagerName === null || projectSecManagerName.trim().length < 1) {
            return this.formValidation.suaProjectSecManagerNameError = false;
        } else if (projectSecManagerName.trim().length < 2) {
            return this.formValidation.suaProjectSecManagerNameError = true;
        }
        return this.formValidation.suaProjectSecManagerNameError = false;
    }

    /**
     * Validate phone number
     * @param projectSecHandlerPhone 
     * @returns 
     */
     validateProjectSecManagerPhone(projectSecHandlerPhone: any) {
        projectSecHandlerPhone = projectSecHandlerPhone.replaceAll(" ", "")  // strip out all white spaces
        if (projectSecHandlerPhone === null || projectSecHandlerPhone.trim().length < 1) {
            return this.formValidation.suaProjectSecManagerPhoneError = false;
        } else if (projectSecHandlerPhone != null && projectSecHandlerPhone.trim().length < 5) {
           return this.formValidation.suaProjectSecManagerPhoneError = true;           
        } else {        
            if (!projectSecHandlerPhone.match(/^[0-9-+]+$/g)) {                
                return this.formValidation.suaProjectSecManagerPhoneError = true;
            } else {
                return this.formValidation.suaProjectSecManagerPhoneError = false;                
            }
       }       
    }

    /**
     * Validate project sec handler email
     * @param projectSecHandlerMail 
     * @returns 
     */
     validateProjectSecManagerMail(projectSecHandlerMail) {
        if (projectSecHandlerMail === null || projectSecHandlerMail.length < 1) {
            return this.formValidation.suaProjectSecManagerMailError = false;
        } else if (!this.isValidContactMail(projectSecHandlerMail)) {           
            return this.formValidation.suaProjectSecManagerMailError = true;
        }
        return this.formValidation.suaProjectSecManagerMailError = false;
    }

    /**
     * Validate name clarification
     * @param nameClarification 
     */
    validateNameClarification(nameClarification) {
        if (nameClarification === null || nameClarification.trim().length < 1) {
            return this.formValidation.suaNameClarificationError = false;
        } else if (nameClarification.trim().length < 2) {
            return this.formValidation.suaNameClarificationError = true;
        }
        return this.formValidation.suaNameClarificationError = false;
    }
}